const getUserData = () => {
    return JSON.parse(localStorage.getItem('user')).userData;
}

export default getUserData;
